const problemsTypesMap = {
  FROZEN_HODOMETER: 'Hodômetro Congelado',
  YELLOW_FEVER: 'Febre Amarela',
  RED_FEVER: 'Febre Vermelha',
  GREY_FEVER: 'Febre Cinza',
  MAX_SPEED: 'Velocidade Topada',
  MAX_RPM: 'RPM Topado',
  MAX_HODOMETER: 'Hodômetro Topado',
  POSITION_JUMP: 'Salto de Posição',
  LAT_LNG_JUMP: 'Salto de Lat/Lng',
  MISSING_SATELLITES: 'Falta de Satélites',
  HODOMETER_JUMP: 'Salto de Hodômetro',
  WEIRD_SPEED: 'Velocidade Estranha',
  CONTACTLESS_DAMAGED: 'Defeito na Contactless',
  CAN_POWER_UP_EXCESS: 'Excesso de CAN Power Up',
  NO_GM_ROUTE_TAKEN: 'Sem Rota Realizada no GM',
  HODOMETER_RESTART: 'Restart do Hodômetro',
  PCOUNT_RESTART: 'Restart do PCount',
  SPEED_FAILURE: 'Falha no Cálculo de Velocidade',
  SCHEDULED_MAINTENANCE: 'Manutenção Agendada',
  HIGH_RPM: 'RPM 70% > Limite Amarelo RPM',
  NO_TRANSMISSION_ISSUE_WITH_RECENT_TRANSMISSION: 'Chamado \'Sem transmissão\' com Veículo Transmitindo',
  HODOMETER_MUCH_BIGGER_THAN_LAT_LNG: 'Hodômetro 300% > LatLng',
  GM_KM_DISPERSION: 'Dispersão de KM GM',
  WINDSHIELD_SENSOR_ERROR: 'Erro no Sensor de Parabrisa',
  CAN_LITE_REBOOTING: 'CAN Lite Reiniciando',
  TOO_MUCH_TRANSMISSION_BY_IGNITION_ON: 'Muitas Transmissões por Ignição Ligada',
  BATTERY_FAILURE: 'Falha de Bateria',
  TELEMETRY_OFF: 'Telemetria Off',
  CONTACTLESS_NOT_SYNCHRONIZED: 'Contactless não Sincronizada',
  CAN_OUTDATED_HODOMETER: 'Hodômetro CAN Desatualizado',
  FROZEN_LAT_LNG: 'Lat/Lng Congelada',
  COORDINATE_TRANSMISSION_EXCESS: 'Excesso de Transmissão de Coordenadas',
  LONG_IGNITION_ON: 'Ignição ligada há muito tempo',
  GHOST_RPM: 'RPM Fantasma',
  GHOST_SPEED: 'Velocidade Fantasma',
  COORDINATE_GAP: 'GAP de Coordenadas',
  OUTDATED_FIRMWARE_VERSION: 'Versão de Firmware desatualizada',
  INCORRECT_PROFILE_FOR_CAN_VEHICLE: 'Veículo CAN com perfil incorreto',
  INCORRECT_PROFILE_FOR_NO_CAN_VEHICLE: 'Veículo sem CAN com perfil incorreto',
  CHILL: 'Calafrio',
  LACK_OF_FEEDING: 'Falta de Alimentação',
  INTERMITTENT_EXTERNAL_VOLTAGE: "Voltagem Externa Intermitente"
};

export default problemsTypesMap;



// WEBPACK FOOTER //
// ./src/commons/ProblemsTypesMap.js